// export const baseURL = "http://readerfeader.com";
// export const baseURL = "https://classified-ads-backend.onrender.com";

// export const baseURL = "https://api.crosslinker.us";
// export const baseURL = "http://192.168.0.39:1609/api/v1";
// export const baseURL = "http://digimonk.co:1609/api/v1";
export const baseURL = process.env.REACT_APP_PUBLIC_API_BASE_URL; //"https://admin.crosslinker.us/api/v1";

//export const baseURL = "https://cladata.onrender.com";
// export const baseURL = "https://cladata-klk2.onrender.com";
//export const baseURL = "https://classified-data-backend.onrender.com";
